import { render, staticRenderFns } from "./accessDetails.vue?vue&type=template&id=886f09c6&scoped=true"
import script from "./accessDetails.vue?vue&type=script&lang=js"
export * from "./accessDetails.vue?vue&type=script&lang=js"
import style0 from "./accessDetails.vue?vue&type=style&index=0&id=886f09c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886f09c6",
  null
  
)

export default component.exports